var isWin = process.platform === 'win32';

module.exports = function (str) {
	while (endsInSeparator(str)) {
		str = str.slice(0, -1);
	}
	return str;
};

function endsInSeparator(str) {
	var last = str[str.length - 1];
	return str.length > 1 && (last === '/' || (isWin && last === '\\'));
}



//////////////////
// WEBPACK FOOTER
// ./~/remove-trailing-separator/index.js
// module id = 201
// module chunks = 0